import { SymbolType } from '../../types/symbol.js';

/* eslint-disable @typescript-eslint/naming-convention */
const BulletShape = Object.assign(Object.assign({}, SymbolType), { Line: 'line' });
var BulletLegendOrientation;
(function (BulletLegendOrientation) {
    BulletLegendOrientation["Horizontal"] = "horizontal";
    BulletLegendOrientation["Vertical"] = "vertical";
})(BulletLegendOrientation || (BulletLegendOrientation = {}));

export { BulletLegendOrientation, BulletShape };
//# sourceMappingURL=types.js.map
